import React from 'react'
import '../App.css'
import { useState, useRef, useEffect } from 'react'
import Burger from "./Burger"
import Menu from "./Menu";

const useOnClickOutside = (ref, handler) => {
    useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) return
      handler(event)
    };
    document.addEventListener("mousedown", listener)

    return () => {
      document.removeEventListener("mousedown", listener)
    };
  }, [ref, handler])
}

export default function Header() {
const [open, setOpen] = useState(false)
const node = useRef()

useOnClickOutside(node, () => setOpen(false))

return (
    <div ref={node}>
    <Burger open={open} setOpen={setOpen} />
    <Menu open={open} setOpen={setOpen} />
    </div>
)
}  